import { render, staticRenderFns } from "./RealmGuideValue.vue?vue&type=template&id=988c8b28&scoped=true&"
import script from "./RealmGuideValue.vue?vue&type=script&lang=js&"
export * from "./RealmGuideValue.vue?vue&type=script&lang=js&"
import style0 from "./RealmGuideValue.vue?vue&type=style&index=0&id=988c8b28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988c8b28",
  null
  
)

export default component.exports